import { doLogout } from "actions/authAction";

import {
  BASE_URL,
} from "./constant";

export const SEARCH_BIAYA_PENGIRIMAN_LOADING = 'SEARCH_BIAYA_PENGIRIMAN_LOADING';
export const SEARCH_BIAYA_PENGIRIMAN_SUCCESS = 'SEARCH_BIAYA_PENGIRIMAN_SUCCESS';
export const SEARCH_BIAYA_PENGIRIMAN_ERROR = 'SEARCH_BIAYA_PENGIRIMAN_ERROR';

const searchBiayaPengirimanLoading = (bool) => {
  return {
    type: SEARCH_BIAYA_PENGIRIMAN_LOADING,
    searchBiayaPengirimanLoading: bool
  };
};

const searchBiayaPengirimanSuccess = (bool, biayaPengiriman) => {
  return {
    type: SEARCH_BIAYA_PENGIRIMAN_SUCCESS,
    searchBiayaPengirimanSuccess: bool,
    biayaPengiriman
  };
};

const searchBiayaPengirimanError = (bool) => {
  return {
    type: SEARCH_BIAYA_PENGIRIMAN_ERROR,
    searchBiayaPengirimanError: bool
  };
};

export function searchBiayaPengiriman(data) {
  return (dispatch) => {
    dispatch(searchBiayaPengirimanLoading(true));
    dispatch(searchBiayaPengirimanSuccess(false, []));
    dispatch(searchBiayaPengirimanError(false));
    
    let config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(BASE_URL + 'portal/get-biaya-pengurusan', config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }
      if (!response.ok) {
        throw Error(response.statusText);
      }
      dispatch(searchBiayaPengirimanLoading(false));
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.success === true) {
        dispatch(searchBiayaPengirimanSuccess(true, data));
      }
      else {
        alert(data.message);
      }
    })
    .catch((err) => {
      dispatch(searchBiayaPengirimanError(true));
    });
  };
};

export function searchBiayaPengirimanNew(data) {
  return (dispatch) => {
    dispatch(searchBiayaPengirimanLoading(true));
    dispatch(searchBiayaPengirimanSuccess(false, []));
    dispatch(searchBiayaPengirimanError(false));
    
    let config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(BASE_URL + 'master_tarif/portal', config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout());
      }
      if (!response.ok) {
        throw Error(response.statusText);
      }
      dispatch(searchBiayaPengirimanLoading(false));
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.success === true) {
        dispatch(searchBiayaPengirimanSuccess(true, data));
      }
      else {
        alert(data.message);
      }
    })
    .catch((err) => {
      dispatch(searchBiayaPengirimanError(true));
    });
  };
};